import axios from 'src/api/axiosInstances/privateAxiosInstance';
import {
  AlertList,
  AlertCriteria,
  AlertCriteriaList,
  CreateEditAlertDetails,
  MonitoredSegment,
  AlertRun,
  PriceCollectedTime,
} from '../types/AlertConfiguration';

export const createEditAlert = (body: CreateEditAlertDetails.Request): Promise<CreateEditAlertDetails.Response> => {
  return axios.post('qm/alert/add', body);
};

export const createEditAlertCriteria = (body: AlertCriteria.RequestBody): Promise<unknown> => {
  return axios.post('qm/alertcriteria/add', body);
};

export const runAlert = (body: AlertRun.Request): Promise<AlertRun.Response> => {
  return axios.post('qm/alertresult/create', body);
};

export const priceCollectedTime = (sourceOwnerId: string): Promise<PriceCollectedTime.Response> => {
  return axios.get(`qm/product/pricecollectedtime?sourceOwnerID=${sourceOwnerId}`);
};

export const getAlerts = (params: AlertList.Request): Promise<AlertList.Response> => {
  return axios.get('qm/alert/retrieve', { params });
};

export const removeAlert = (id: number) => {
  return axios.delete(`qm/alert/remove?alertId=${id}`);
};

export const getAlertCriteria = (params: AlertCriteriaList.Request): Promise<AlertCriteriaList.Response> => {
  return axios.get('qm/alertcriteria/retrieve', { params });
};

export const getMonitoredSegments = (): Promise<MonitoredSegment.Response> => {
  return axios.get('qm/productsegment/retrivesegments');
};
